export default "/img/connect.7ca6cc67d0824fd86b93fc584e7677a5.ico";